/* eslint-disable jsx-a11y/media-has-caption */

import React, { useState, useEffect, useRef } from 'react';
// import videojs from 'video.js';
import { tile_vid } from "~/styles/shared/img_grid.module.scss";

const VideoBg = ({ options, vidclasses, desk_vid_class, off }) => {
  const [player, setPlayer] = useState(null)
  const videoRef = useRef(null)
  const playerRef = useRef(null)

  const initVideo = () => {
    if (player) return
    if (!videoRef.current) return

    const videojs = ((typeof window !== 'undefined') && window.videojs) || null
    setPlayer(videojs(videoRef.current, options))
  }

  useEffect(() => {
    if (player) return
    const videojs = ((typeof window !== 'undefined') && window.videojs) || null
    if (!videojs) {
      setTimeout(() => {
        if (!player) initVideo()
      }, 400)
      return
    }
    
    initVideo()

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose()
        setPlayer(null)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <div 
      className={`${(typeof vidclasses !== 'undefined') ? vidclasses : ''} ${(typeof desk_vid_class !== 'undefined') ? desk_vid_class : ''}`} 
    >
      <div className={`${tile_vid}`} data-vjs-player="">
        <video ref={videoRef} className="video-js" muted={true} />
      </div>
    </div>
  );
};

export default VideoBg


// import { checkMobile } from '../utils/helpers'

// const Video = ({ video, vidclasses, desk_vid_class }) => {

//   return (
//     <div 
//       className={`gallvid data-hj-suppress ${(typeof vidclasses !== 'undefined') ? vidclasses : ''} ${(typeof desk_vid_class !== 'undefined') ? desk_vid_class : ''}`} 
//       data-vid-num="<%= vid_ind %>" 
//       data-hj-suppress=""
//     >
//       <img src={video.src} className="swipe_img" loading="lazy" width="400" height="532" alt="" />
//     </div>
//   )
// }

// export default Video
